import escapeXml from 'utils/escapeXml';
import generateKmlPlacemark from 'utils/generateKmlPlacemark';
import getFlightGroupKey from 'utils/getFlightGroupKey';
import groupBy from 'utils/groupBy';

import {
    DOCUMENT_CLOSE,
    DOCUMENT_OPEN,
    FOLDER_CLOSE,
    FOLDER_OPEN,
    KML_NAMESPACE,
    NAME_CLOSE,
    NAME_OPEN,
    XML_DECLARATION
} from './constants';
import type { FlightResponse, GenerateKml } from './types';

const buildPlacemarks = (flights: FlightResponse[]): string =>
    flights.map(generateKmlPlacemark).filter(Boolean).join('\n');

const buildFolders = (groups: Map<string, FlightResponse[]>): string =>
    [...groups.entries()]
        .map(([dateKey, groupFlights]) =>
            [
                FOLDER_OPEN,
                `  ${NAME_OPEN}${escapeXml(dateKey)}${NAME_CLOSE}`,
                buildPlacemarks(groupFlights),
                FOLDER_CLOSE
            ].join('\n')
        )
        .join('\n');

const generateKml: GenerateKml = flights => {
    const groups = groupBy(flights, getFlightGroupKey);
    const isSingleGroup = groups.size <= 1;
    const content = isSingleGroup ? buildPlacemarks(flights) : buildFolders(groups);

    return [
        XML_DECLARATION,
        `<kml xmlns="${KML_NAMESPACE}">`,
        DOCUMENT_OPEN,
        content,
        DOCUMENT_CLOSE,
        '</kml>'
    ].join('\n');
};

export default generateKml;
